/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateScanMetaData = {
    /**
     * Type of the scanner used.
     */
    scannerType: CreateScanMetaData.scannerType;
    /**
     * Encoding of the resulted model.
     */
    encoding: CreateScanMetaData.encoding;
    /**
     * Bodypart that has been scanned.
     */
    bodyPart: CreateScanMetaData.bodyPart;
    /**
     * Type of the scanner used.
     */
    side?: CreateScanMetaData.side;
    /**
     * Bodypart that has been scanned.
     */
    foot: CreateScanMetaData.foot;
    /**
     * serial number of the 3D scanner
     */
    serial: string;
    /**
     * firmware version of the 3D scanner
     */
    firmware: string;
    /**
     * Software with which the scan was made, e.g. rs scan agent 2.0.24
     */
    origin: string;
    /**
     * Timestamp of the scanning session.
     */
    timestamp: number;
    /**
     * Scan mode used.
     */
    scanMode?: CreateScanMetaData.scanMode;
    /**
     * The product the scan is a reference for.
     */
    product?: CreateScanMetaData.product;
};
export namespace CreateScanMetaData {
    /**
     * Type of the scanner used.
     */
    export enum scannerType {
        MOCK_SCANNER = 'MOCK_SCANNER',
        TIGER = 'TIGER',
        I_QUBE_E303 = 'iQUBE_E303',
        UNKNOWN_DEVICE_MODEL = 'UNKNOWN_DEVICE_MODEL',
        INVALID_DEVICE_MODEL = 'INVALID_DEVICE_MODEL',
        OCCIPITAL_ST02A = 'OCCIPITAL_ST02A',
        OCCIPITAL_ST02B = 'OCCIPITAL_ST02B',
        TRUEDEPTH = 'TRUEDEPTH',
    }
    /**
     * Encoding of the resulted model.
     */
    export enum encoding {
        RAW = 'RAW',
        STL = 'STL',
        OBJ = 'OBJ',
        DRACO = 'DRACO',
    }
    /**
     * Bodypart that has been scanned.
     */
    export enum bodyPart {
        FOOT = 'FOOT',
        FOOT_AND_ANKLE = 'FOOT_AND_ANKLE',
        HEAD = 'HEAD',
        TORSO = 'TORSO',
    }
    /**
     * Type of the scanner used.
     */
    export enum side {
        LEFT = 'LEFT',
        RIGHT = 'RIGHT',
        BOTH = 'BOTH',
    }
    /**
     * Bodypart that has been scanned.
     */
    export enum foot {
        LEFT = 'LEFT',
        RIGHT = 'RIGHT',
        UNKNOWN = 'UNKNOWN',
    }
    /**
     * Scan mode used.
     */
    export enum scanMode {
        WEIGHTED = 'WEIGHTED',
        NON_WEIGHTED = 'NON-WEIGHTED',
        SEMI_WEIGHTED = 'SEMI-WEIGHTED',
        FOAMBOX = 'FOAMBOX',
    }
    /**
     * The product the scan is a reference for.
     */
    export enum product {
        INSOLE = 'INSOLE',
        AFO = 'AFO',
        HELMET = 'HELMET',
    }
}

